import { Component, OnInit } from '@angular/core';
import { DatabaseService } from '../../_services/DatabaseService';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogComponent } from '../../dialog/dialog.component';
import { SessionStorage } from '../../_services/SessionService';
import { MatDialog } from '@angular/material';

@Component({
  selector: 'app-influencer-catalogue-list',
  templateUrl: './influencer-catalogue-list.component.html',
})
export class InfluencerCatalogueListComponent implements OnInit {

  savingData = false;
  category: any = {};
  loading_list = false;
  categories: any = [];
  // 'Customer','Influencer'
  userTypeOptions: any = ['Plumber', 'Dealer', 'Distributor'];
  selectedTypes: any = [];

  constructor(public db: DatabaseService, private route: ActivatedRoute, private router: Router, public ses: SessionStorage,
    public dialog: DialogComponent, public alrt: MatDialog) { }

  ngOnInit() {
    this.getCategoryList();
  }

  filter: any = {};

  toggle: any;

  pdfFile: any = null;
  pdfFileName: any = '';
  onPdfChange(evt: any) {
    const file = evt.target.files[0];
    if (file) {
      this.pdfFile = file;
      this.pdfFileName = file.name;
    }
  }

  savecategory(form: any) {

    if (!this.pdfFile && !this.category.id) {
      this.dialog.error('Please select a PDF file');
      return;
    }

    if (!this.selectedTypes.length) {
      this.dialog.error('Please select at least one User Type');
      return;
    }

    this.savingData = true;

    const formData = new FormData();
    if (this.category.id) {
      formData.append('id', this.category.id);
    }
    formData.append('title', this.category.title);
    formData.append('type', this.selectedTypes.join(','));
    formData.append('created_by', this.db.datauser.id);
    if (this.pdfFile) {
      formData.append('pdf', this.pdfFile, this.pdfFile.name);
    }

    this.db.fileData(formData, 'master/addInfluencerCatalogue')
      .subscribe(d => {
        this.savingData = false;
        if (d['status'] != 'SUCCESS') {
          this.dialog.error('Could not save, please try again');
          return;
        }
        this.toggle = "false";
        this.clearData();

        this.router.navigate(['influencer-catalogue-list']);
        this.dialog.success('Influencer Catalogue successfully saved');
        this.getCategoryList();
      }, err => {
        this.savingData = false;
      });
  }

  addCategory() {
    this.clearData();
  }

  editCatalogue(item: any) {
    this.category = { id: item.id, title: item.title };
    this.selectedTypes = item.type.split(',').filter(t => t);
    this.pdfFile = null;
    this.pdfFileName = item.pdf;
  }

  getCategoryList() {

    this.loading_list = true;
    this.db.post_rqst({ 'filter': this.filter }, 'master/influencerCatalogueList')
      .subscribe(d => {

        this.loading_list = false;
        this.categories = d.categories;
      });
  }

  deleteProduct(id) {
    this.dialog.delete('Influencer Catalogue').then((result) => {
      if (result) {
        this.db.post_rqst({ category_id: id }, 'master/influencerCatalogueDelete')
          .subscribe(d => {
            this.getCategoryList();
            this.dialog.successfully();
          });
      }
    });
  }

  clearData() {
    this.category = {};
    this.pdfFile = null;
    this.pdfFileName = '';
    this.selectedTypes = [];
  }

}
